export const OpenEye = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20">
      <g fill="currentColor">
        <path d="M10 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4Z" />
        <path
          fillRule="evenodd"
          d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10ZM14 10a4 4 0 1 1-8 0a4 4 0 0 1 8 0Z"
          clipRule="evenodd"
        />
      </g>
    </svg>
  );
};

export const CloseEye = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M4.52 5.935L1.394 2.808l1.414-1.414l19.799 19.798l-1.414 1.415l-3.31-3.31A10.949 10.949 0 0 1 12 21c-5.392 0-9.878-3.88-10.818-9A10.982 10.982 0 0 1 4.52 5.935Zm10.238 10.237l-1.464-1.464a3 3 0 0 1-4.001-4.001L7.829 9.243a5 5 0 0 0 6.929 6.929ZM7.974 3.76C9.221 3.27 10.58 3 12 3c5.392 0 9.878 3.88 10.819 9a10.947 10.947 0 0 1-2.012 4.593l-3.86-3.86a5 5 0 0 0-5.68-5.68L7.975 3.76Z"
      />
    </svg>
  );
};

export const DashboardIcon = ({activeLink}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 24 24">
      <path
        fill={activeLink === '/' ? '#F0BD2D' : 'currentColor'}
        d="M3 3h8v10H3V3zm2 2v6h4V5H5zm8-2h8v6h-8V3zm2 2v2h4V5h-4zm-2 6h8v10h-8V11zm2 2v6h4v-6h-4zM3 15h8v6H3v-6zm2 2v2h4v-2H5z"
      />
    </svg>
  );
};

export const Report = ({activeLink}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 24 24">
      <path
        fill="none"
        stroke={activeLink === 'report' ? '#F0BD2D' : 'currentColor'}
        strokeWidth="1.5"
        d="M9 21h6m-6 0v-5m0 5H3.6a.6.6 0 0 1-.6-.6v-3.8a.6.6 0 0 1 .6-.6H9m6 5V9m0 12h5.4a.6.6 0 0 0 .6-.6V3.6a.6.6 0 0 0-.6-.6h-4.8a.6.6 0 0 0-.6.6V9m0 0H9.6a.6.6 0 0 0-.6.6V16"
      />
    </svg>
  );
};

export const Hamburger = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24">
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M3 17h18M3 12h18M3 7h18"
      />
    </svg>
  );
};

export const Times = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 20 20">
      <g fill="currentColor">
        <path d="M7.172 14.243a1 1 0 1 1-1.415-1.415l7.071-7.07a1 1 0 1 1 1.415 1.414l-7.071 7.07Z" />
        <path d="M5.757 7.172a1 1 0 0 1 1.415-1.415l7.07 7.071a1 1 0 1 1-1.414 1.415l-7.07-7.071Z" />
      </g>
    </svg>
  );
};

// export const ArrowUp = () => {
//   return (
//     <svg
//       xmlns="http://www.w3.org/2000/svg"
//       width="12"
//       height="21.34"
//       viewBox="0 0 9 16">
//       <path
//         fill="currentColor"
//         d="M4.5 14c-.28 0-.5-.22-.5-.5v-9c0-.28.22-.5.5-.5s.5.22.5.5v9c0 .28-.22.5-.5.5Z"
//       />
//       <path
//         fill="currentColor"
//         d="M8 7.5a.47.47 0 0 1-.35-.15L4.5 4.2L1.35 7.35c-.2.2-.51.2-.71 0c-.2-.2-.2-.51 0-.71l3.5-3.5c.2-.2.51-.2.71 0l3.5 3.5c.2.2.2.51 0 .71c-.1.1-.23.15-.35.15Z"
//       />
//     </svg>
//   );
// };

export const ChevronUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6l-6 6l1.41 1.41Z"
      />
    </svg>
  );
};

export const ChevronDown = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M7.41 8.58L12 13.17l4.59-4.59L18 10l-6 6l-6-6l1.41-1.42Z"
      />
    </svg>
  );
};

export function LoadingIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <circle cx="18" cy="12" r="0" fill="currentColor">
        <animate
          attributeName="r"
          begin=".67"
          calcMode="spline"
          dur="1.5s"
          keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
          repeatCount="indefinite"
          values="0;2;0;0"
        />
      </circle>
      <circle cx="12" cy="12" r="0" fill="currentColor">
        <animate
          attributeName="r"
          begin=".33"
          calcMode="spline"
          dur="1.5s"
          keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
          repeatCount="indefinite"
          values="0;2;0;0"
        />
      </circle>
      <circle cx="6" cy="12" r="0" fill="currentColor">
        <animate
          attributeName="r"
          begin="0"
          calcMode="spline"
          dur="1.5s"
          keySplines="0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8"
          repeatCount="indefinite"
          values="0;2;0;0"
        />
      </circle>
    </svg>
  );
}

export function DonwloadIcon(){
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24"><path fill="#FFFFFF" d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/></svg>
  )
}

export function CustomerAuditIcon({activeLink}){
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g fill="none" stroke={activeLink === 'customer-audit-log' ? '#F0BD2D' : '#fff'} strokeWidth="2.5"><path strokeLinejoin="round" d="M4 18a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z"/><circle cx="12" cy="7" r="3"/></g></svg>
  )
}

export function HandleMemberQueryIcon({ activeLink }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_1811_30066" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9"/>
      </mask>
      <g mask="url(#mask0_1811_30066)">
        <path
          d="M1.67188 15.8333V14.1667H10.0052V15.8333H1.67188ZM1.67188 11.6667V10H5.83854V11.6667H1.67188ZM1.67188 7.5V5.83333H5.83854V7.5H1.67188ZM17.1719 15.8333L13.9635 12.625C13.6302 12.8611 13.2656 13.0382 12.8698 13.1563C12.474 13.2743 12.0747 13.3333 11.6719 13.3333C10.5191 13.3333 9.53646 12.9271 8.72396 12.1146C7.91146 11.3021 7.50521 10.3194 7.50521 9.16667C7.50521 8.01389 7.91146 7.03125 8.72396 6.21875C9.53646 5.40625 10.5191 5 11.6719 5C12.8247 5 13.8073 5.40625 14.6198 6.21875C15.4323 7.03125 15.8385 8.01389 15.8385 9.16667C15.8385 9.56944 15.7795 9.96875 15.6615 10.3646C15.5434 10.7604 15.3663 11.125 15.1302 11.4583L18.3385 14.6667L17.1719 15.8333ZM11.6719 11.6667C12.3663 11.6667 12.9566 11.4236 13.4427 10.9375C13.9288 10.4514 14.1719 9.86111 14.1719 9.16667C14.1719 8.47222 13.9288 7.88194 13.4427 7.39583C12.9566 6.90972 12.3663 6.66667 11.6719 6.66667C10.9774 6.66667 10.3872 6.90972 9.90104 7.39583C9.41493 7.88194 9.17188 8.47222 9.17188 9.16667C9.17188 9.86111 9.41493 10.4514 9.90104 10.9375C10.3872 11.4236 10.9774 11.6667 11.6719 11.6667Z"
          fill={activeLink === 'handle-member-query' ? '#F0BD2D' : 'white'}
        />
      </g>
    </svg>
  );
}

export function DonwloadIcon1({ color = "#00305E" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" viewBox="0 0 24 24">
      <path fill={color} d="m12 16l-5-5l1.4-1.45l2.6 2.6V4h2v8.15l2.6-2.6L17 11zm-6 4q-.825 0-1.412-.587T4 18v-3h2v3h12v-3h2v3q0 .825-.587 1.413T18 20z"/>
    </svg>
  )
}

export const PointsManagementIcon = () => (
    <svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.24375 10.2563C5.08125 9.09375 4.5 7.675 4.5 6C4.5 4.325 5.08125 2.90625 6.24375 1.74375C7.40625 0.58125 8.825 0 10.5 0C12.175 0 13.5938 0.58125 14.7563 1.74375C15.9188 2.90625 16.5 4.325 16.5 6C16.5 7.675 15.9188 9.09375 14.7563 10.2563C13.5938 11.4187 12.175 12 10.5 12C8.825 12 7.40625 11.4187 6.24375 10.2563ZM4.5 11.8125C3.175 11.4625 2.09375 10.75 1.25625 9.675C0.41875 8.6 0 7.375 0 6C0 4.625 0.41875 3.4 1.25625 2.325C2.09375 1.25 3.175 0.5375 4.5 0.1875V1.7625C3.6 2.075 2.875 2.61875 2.325 3.39375C1.775 4.16875 1.5 5.0375 1.5 6C1.5 6.9625 1.775 7.83125 2.325 8.60625C2.875 9.38125 3.6 9.925 4.5 10.2375V11.8125ZM13.6875 9.1875C14.5625 8.3125 15 7.25 15 6C15 4.75 14.5625 3.6875 13.6875 2.8125C12.8125 1.9375 11.75 1.5 10.5 1.5C9.25 1.5 8.1875 1.9375 7.3125 2.8125C6.4375 3.6875 6 4.75 6 6C6 7.25 6.4375 8.3125 7.3125 9.1875C8.1875 10.0625 9.25 10.5 10.5 10.5C11.75 10.5 12.8125 10.0625 13.6875 9.1875Z" fill="#809DB2"/>
    </svg>
);

export const PointsAwardIcon = ({ activeLink }) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1941_5765" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1941_5765)">
      <path
        d="M7.2 11.7375L9 10.35L10.8 11.7375L10.125 9.45L11.8125 8.25H9.7125L9 5.925L8.2875 8.25H6.1875L7.875 9.45L7.2 11.7375ZM4.36875 15.75L6.1125 10.05L1.5 6.75H7.2L9 0.75L10.8 6.75H16.5L11.8875 10.05L13.6313 15.75L9 12.225L4.36875 15.75Z"
        fill={activeLink === "points-award" ? "#fff" : "#809DB2"}
      />
    </g>
  </svg>
);

export const TransactionChannelIcon = ({ activeLink }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.3308 14.6654H5.82277C5.80824 14.6653 5.79398 14.6615 5.78128 14.6545C5.76858 14.6474 5.75786 14.6373 5.7501 14.625L2.61743 9.57436C2.52038 9.42082 2.45494 9.24945 2.42497 9.0703C2.39499 8.89114 2.40107 8.7078 2.44286 8.53103C2.48464 8.35425 2.56129 8.1876 2.66831 8.04082C2.77533 7.89405 2.91057 7.77011 3.0661 7.67628C3.22163 7.58244 3.39432 7.52059 3.57406 7.49435C3.75381 7.46811 3.93698 7.47801 4.11284 7.52346C4.28871 7.56892 4.45373 7.64902 4.59825 7.75907C4.74276 7.86913 4.86385 8.00691 4.95443 8.16436L5.7751 9.56236V2.64603C5.7751 2.29754 5.91354 1.96332 6.15996 1.71689C6.40638 1.47047 6.7406 1.33203 7.0891 1.33203C7.43759 1.33203 7.77181 1.47047 8.01824 1.71689C8.26466 1.96332 8.4031 2.29754 8.4031 2.64603V5.7557C8.4031 5.9507 8.5581 6.11103 8.7531 6.11737L12.6268 6.2467C12.8156 6.25301 12.9946 6.33248 13.126 6.46832C13.2574 6.60416 13.3308 6.78573 13.3308 6.9747V13.6654C13.3308 13.9306 13.2254 14.1849 13.0379 14.3725C12.8503 14.56 12.596 14.6654 12.3308 14.6654Z" 
      stroke={activeLink === "transaction-channel" ? "#F0BD2D" : "#809DB2"} 
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TransactionChannelsIcon = ({ activeLink }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 11.5C10.6569 11.5 12 10.1569 12 8.5C12 6.84315 10.6569 5.5 9 5.5C7.34315 5.5 6 6.84315 6 8.5C6 10.1569 7.34315 11.5 9 11.5Z"
      stroke={activeLink === "transaction-channels" ? "#fff" : "#809DB2"}
      strokeWidth="1.5"
    />
    <path
      d="M3 19C3 15.6863 5.68629 13 9 13C12.3137 13 15 15.6863 15 19"
      stroke={activeLink === "transaction-channels" ? "#fff" : "#809DB2"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M17 8H21M19 6V10"
      stroke={activeLink === "transaction-channels" ? "#fff" : "#809DB2"}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export const PointsApprovalsIcon = ({ activeLink }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke={activeLink === "points-approvals" ? "#fff" : "#809DB2"}
      strokeWidth="1.5"
    />
    <path
      d="M8 12.5L10.5 15L16 9"
      stroke={activeLink === "points-approvals" ? "#fff" : "#809DB2"}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);